var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

// eslint-disable-next-line no-unused-vars
var _require = require('./inline-text-builder'),
    InlineTextBuilder = _require.InlineTextBuilder; // eslint-disable-next-line import/no-unassigned-import


require('./typedefs');

function charactersToCodes(str) {
  return _toConsumableArray(str).map(function (c) {
    return "\\u" + c.charCodeAt(0).toString(16).padStart(4, '0');
  }).join('');
}
/**
 * Helps to handle HTML whitespaces.
 *
 * @class WhitespaceProcessor
 */


var WhitespaceProcessor = /*#__PURE__*/function () {
  "use strict";

  /**
   * Creates an instance of WhitespaceProcessor.
   *
   * @param { Options } options    HtmlToText options.
   * @memberof WhitespaceProcessor
   */
  function WhitespaceProcessor(options) {
    _classCallCheck(this, WhitespaceProcessor);

    this.whitespaceChars = options.preserveNewlines ? options.whitespaceCharacters.replace(/\n/g, '') : options.whitespaceCharacters;
    var whitespaceCodes = charactersToCodes(this.whitespaceChars);
    this.leadingWhitespaceRe = new RegExp("^[".concat(whitespaceCodes, "]"));
    this.trailingWhitespaceRe = new RegExp("[".concat(whitespaceCodes, "]$"));
    this.allWhitespaceOrEmptyRe = new RegExp("^[".concat(whitespaceCodes, "]*$"));

    if (options.preserveNewlines) {
      var wordOrNewlineRe = new RegExp("\n|[^\n".concat(whitespaceCodes, "]+"), 'gm');
      /**
       * Shrink whitespaces and wrap text, add to the builder.
       *
       * @param { string }                  text              Input text.
       * @param { InlineTextBuilder }       inlineTextBuilder A builder to receive processed text.
       * @param { (str: string) => string } [ transform ]     A transform to be applied to words.
       */

      this.shrinkWrapAdd = function (text, inlineTextBuilder) {
        var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (str) {
          return str;
        };

        if (!text) {
          return;
        }

        var previouslyStashedSpace = inlineTextBuilder.stashedSpace;
        var anyMatch = false;
        var m = wordOrNewlineRe.exec(text);

        if (m) {
          anyMatch = true;

          if (m[0] === '\n') {
            inlineTextBuilder.startNewLine();
          } else if (previouslyStashedSpace || this.testLeadingWhitespace(text)) {
            inlineTextBuilder.pushWord(transform(m[0]));
          } else {
            inlineTextBuilder.concatWord(transform(m[0]));
          }

          while ((m = wordOrNewlineRe.exec(text)) !== null) {
            if (m[0] === '\n') {
              inlineTextBuilder.startNewLine();
            } else {
              inlineTextBuilder.pushWord(transform(m[0]));
            }
          }
        }

        inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text); // No need to stash a space in case last added item was a new line,
        // but that won't affect anything later anyway.
      };
    } else {
      var wordRe = new RegExp("[^".concat(whitespaceCodes, "]+"), 'g');

      this.shrinkWrapAdd = function (text, inlineTextBuilder) {
        var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (str) {
          return str;
        };

        if (!text) {
          return;
        }

        var previouslyStashedSpace = inlineTextBuilder.stashedSpace;
        var anyMatch = false;
        var m = wordRe.exec(text);

        if (m) {
          anyMatch = true;

          if (previouslyStashedSpace || this.testLeadingWhitespace(text)) {
            inlineTextBuilder.pushWord(transform(m[0]));
          } else {
            inlineTextBuilder.concatWord(transform(m[0]));
          }

          while ((m = wordRe.exec(text)) !== null) {
            inlineTextBuilder.pushWord(transform(m[0]));
          }
        }

        inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text);
      };
    }
  }
  /**
   * Test whether the given text starts with HTML whitespace character.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */


  _createClass(WhitespaceProcessor, [{
    key: "testLeadingWhitespace",
    value: function testLeadingWhitespace(text) {
      return this.leadingWhitespaceRe.test(text);
    }
    /**
     * Test whether the given text ends with HTML whitespace character.
     *
     * @param   { string }  text  The string to test.
     * @returns { boolean }
     */

  }, {
    key: "testTrailingWhitespace",
    value: function testTrailingWhitespace(text) {
      return this.trailingWhitespaceRe.test(text);
    }
    /**
     * Test whether the given text contains any non-whitespace characters.
     *
     * @param   { string }  text  The string to test.
     * @returns { boolean }
     */

  }, {
    key: "testContainsWords",
    value: function testContainsWords(text) {
      return !this.allWhitespaceOrEmptyRe.test(text);
    }
  }]);

  return WhitespaceProcessor;
}();

module.exports = {
  WhitespaceProcessor: WhitespaceProcessor
};